import { resolveUpload } from '@/lib/resolveUpload';
import { FormValues } from '../form/ManageStoreLineGroupFormView';

export const buildLineGroupPayload = async (data: FormValues) => {
  let QRImage = '';

  if (data.image && typeof data.image === 'object') {
    QRImage = await resolveUpload(data.image);
  }

  return {
    lineGroupName: data.lineGroupName,
    lineQrPath: QRImage || data.existingImageSrc || '',
    lineGroupLink: data.lineGroupLink,
  };
};
